// Миксин для работы со статическими файлами
export const staticFilesMixin = {
  methods: {
    /**
     * Получает правильный URL для статического файла
     * @param {string} path - путь к файлу (например, 'img/theme-1/cat-1.png')
     * @returns {string} - полный URL к файлу
     */
    getStaticUrl(path) {
      // Убираем начальный слеш если есть
      const cleanPath = path.startsWith('/') ? path.substring(1) : path;
      
      // В продакшене статические файлы проксируются через nginx
      // В разработке - через devServer proxy
      return `/static/${cleanPath}`;
    },

    /**
     * Получает URL для спрайта SVG
     * @param {string} iconName - имя иконки в спрайте
     * @returns {string} - путь к иконке в спрайте
     */
    getSpriteUrl(iconName) {
      return `/static/img/sprites/sprite.svg#${iconName}`;
    }
  }
};

// Глобальная функция для использования в шаблонах
export const getStaticUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `/static/${cleanPath}`;
};

export const getSpriteUrl = (iconName) => {
  return `/static/img/sprites/sprite.svg#${iconName}`;
}; 